import {
  Box,
  Text,
  UnorderedList,
  ListItem,
  Container,
} from "@chakra-ui/react";
import Header from "./components/landingPage/Header";
import CallToAction from "./components/landingPage/CallToAction";
import Footer from "./components/landingPage/Footer";
import { useEffect } from "react";

const PrivacyPolicy = () => {
    const handleNavigate = () => {
    window.location.hash = "#/auth/sign-in";
  };
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);
  
  return (
    <>
    <Box className="workspaceHeader">
      <Header handleNavigate={handleNavigate} />
      </Box>
      <Container maxW="container.xl">
        <Box
          className="privacyPolicyContent"
          p={6}
          fontSize="md"
          lineHeight="1.8"
        >
          <Text
            className="privacy-policy-title"
            fontSize="3xl"
            fontWeight="bold"
            mb={4}
          >
            Privacy Policy
          </Text>

          <Text mb={4}>
            This Privacy Policy describes what will take place to any personal
            information that you will share with us, or that we gather from you
            while you visit our website. Also, we do continuous updates to this
            Policy, so please feel free to review this Policy frequently.
          </Text>

          <UnorderedList ml={"30px"} spacing={1} mb={4}>
            <ListItem>Information which is gathered by us from you</ListItem>
            <ListItem>How we utilise the information shared by you</ListItem>
            <ListItem>Storing your personal information</ListItem>
            <ListItem>Unfold your data</ListItem>
            <ListItem>Knock Back 3rd Party links and websites</ListItem>
            <ListItem>Privacy Policy Improvisation</ListItem>
            <ListItem>Adopting this Policy & Terms</ListItem>
          </UnorderedList>

          <Text className="policyPageHeading" mt={5} mb={1}>
            Information which is gathered by us from you
          </Text>
          <Text mb={2}>
            While reviewing our website, we may gather and process the below
            mentioned information:
          </Text>
          <Text mb={2}>
            <strong>Reason to see our website:</strong> Purpose about your use
            of our website include information of your visits like pages viewed
            and the resources that you access. And, such information includes
            traffic data, communication data and location data.
          </Text>
          <Text mb={2}>Information willingly given by you</Text>
          <Text mb={2}>Data that you have shared while you communicate.</Text>
          <Text mb={4} fontWeight="semibold">
            <strong>Note:</strong> We DO NOT store any payment details including your financial
            details like Credit Card or Bank Account details while processing
            for any kind of payment.
          </Text>

          <Text className="policyPageHeading" mt={5} mb={1}>
            How we utilise the information shared by you
          </Text>
          <Text mb={2}>
            We just use the data that we collect from your side to provide you
            our services. Additionally, we may use the information for one or
            more of the below mentioned purposes:
          </Text>
            <Text mb={2}>
              To quickly share the glance of information that you asked from us
              related to our services
            </Text>
            <Text mb={2}>
              To assist you & share the information related to other services
              that may interest you. But some additional required information
              will only be sent to you, if you have consented to receive the
              information.
            </Text>
            <Text mb={2}>
              We may also share the information and details of our services with
              you, if you have previously used our services. As that you may be
              interested in.
            </Text>
            <Text mb={2}>
              And, if you have given your agreement in advance, then only we can
              allow the shortlisted third parties to use your information so
              that they can share the information with you regarding services,
              which we think may interest you. But, if such agreement has been
              shared by you earlier, you can withdraw the same anytime.
            </Text>

          <Text className="policyPageHeading" mt={5} mb={1}>
            Storing your personal information
          </Text>
          <Text mb={4}>
            By providing your personal information, you agree to this access. We
            do our level best to ensure that all the required steps are taken to
            ensure that your data is saved securely. Unfortunately, the
            information you are sending via the Internet is not fully secure and
            it can be intercepted easily. We cannot guarantee the data security
            that you send us electronically because sending such information is
            completely at your own risk.
          </Text>

          <Text className="policyPageHeading" mt={5} mb={1}>
            Unfold your data
          </Text>
          <Text mb={4}>
            We don’t outsource or trade End user's personal information or
            identity information to any third parties. We may share the generic
            aggregated information, which is not related to any personal
            identification information regarding visitors and users with our
            trusted affiliates, business partners and advertisers for the
            marketing purposes.
          </Text>

          <Text className="policyPageHeading" mt={5} mb={1}>
            Knock Back 3rd Party links and websites
          </Text>
          <Text mb={4}>
            We never include the links to the third parties on the website. And,
            even though we rarely provide a link to third parties, that does not
            mean that we endorse or approve our site’s policy towards visitor
            privacy. Do review the third party privacy policy before sending the
            visitors any personal data.
          </Text>

          <Text className="policyPageHeading" mt={5} mb={1}>
            Privacy Policy Improvisation
          </Text>
          <Text mb={4}>
            We can update this privacy policy anytime. And, when we do any
            enhancements, we will definitely revise the updates. We encourage
            users to frequently check the page for any of the changes so that
            they can stay informed about the steps we are taking to protect the
            personal information that we collect. Thus, we are considering that
            you acknowledge and agree that it's solely your responsibility to
            check and review the privacy policy frequently and periodically and
            become aware of the updates and modifications.
          </Text>

          <Text className="policyPageHeading" mt={5} mb={1}>
            Adopting this Policy & Terms
          </Text>
          <Text mb={4}>
            If you are using our website, you signify your acceptance of this
            privacy policy. Your continued use of Benthon Lab’s site following
            the sharing of changes to this privacy policy will be deemed as your
            acceptance of those updates and changes.
          </Text>
        </Box>
      </Container>
      <CallToAction />
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
